import * as log from "./browserConsole";
export function Failure(description: string): never {
  // log.error(`${description}`);
  throw new Error(`${description}`);
}
export const CatchFailure =
  <T>(defaultValue: T) =>
  (f: () => T) => {
    try {
      return f();
    } catch (e: any) {
      log.warn("", e);
      return defaultValue;
    }
  };
